const ValidatorInputCustomPlz = (value, required=true) => {

    let msg = '';

    if (
        required == false
        && value.length < 1
    ) {
        return {
            valid: (true),
            message: ''
        }
    }

    msg += valNumbersOnly(value)
 
    if ( value.length < 5 || value.length > 5) {
        msg += "Das Feld muss genau 5 Stellen beinhalten."
    }

    return {
        valid: (msg.length < 1),
        message: msg
    }
}

const valNumbersOnly = (value) => {

  if ( value.length < 1) {
    return '';
  }

  if ( /^\d+$/.test(value) ) {
    return '';
  }
  return 'Feld darf nur Zahlen enthalten.';
}


export default ValidatorInputCustomPlz;

